export default "__VITE_ASSET__CaZG1s2K__";